const Footer = () => {
  return (
    <div className=" text-center ">
      <hr />
      <p className="py-6">Developed by Jummy © 2024</p>
    </div>
  );
};

export default Footer;
